/**
 * Remove a trailing slash from URL.
 */
export const removeTrailingSlash = (url: string): string => url.replace(/\/+$/, '');
